import { useMemo } from 'react';

import {
    createV3TranscriptAdapter,
    type V3TranscriptAdapter,
} from '@apps/web/features/phoebe_chat_v3/model/adapt_transcript';
import { getCalloutDetailOutreachId } from '@apps/web/lib/chat_access';

export function useV3TranscriptAdapter(): V3TranscriptAdapter {
    const showOutreachPresentations =
        typeof window === 'undefined' ||
        getCalloutDetailOutreachId(window.location.pathname) === null;
    return useMemo(
        () =>
            createV3TranscriptAdapter({
                showOutreachPresentations,
            }),
        [showOutreachPresentations],
    );
}
